import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils/api'
import { showModal } from '../../../actions/_modal'

export const submitCloseJourneySection = async ({
  token,
  orgId,
  id,
  dispatch,
  onCourseSectionUpdate,
  isFetchingCloseSection
}) => {
  isFetchingCloseSection(true)

  const url = `${getApiBaseUrlWithOrg(
    orgId
  )}/mentor/course_sections/${id}/close_section`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PUT',
        headers: getApiHeadersFromToken(token)
      })
    )

    const data = await response.json()
    onCourseSectionUpdate(data)
    isFetchingCloseSection(false)

    return data
  } catch (e) {
    isFetchingCloseSection(false)
    dispatch(showModal('ERROR_CLOSING_JOURNEY_SECTION'))
    return null
  }
}
